import {bindable, customElement, inject} from "aurelia-framework";

@customElement('check-icon')
export class CheckIcon
{
  @bindable() boolValue;
}
